import { useEffect } from "react"
import { navigate } from "gatsby"

const useRedirectToLang = path => {
  useEffect(() => {
    const localLang = localStorage.getItem("senses-integration-language")
    const browserLang = navigator.language.replace(/(-.+)/, "")
    const testLangs = /^\/(en|cn)/
    const testChinese = /^\/cn/
    const testEnglish = /^\/en/
    const testKontakt = /kontakt/
    const testContact = /contact/
    const testProzess = /prozess/
    const testProcess = /process/
    const redirectToLangPath = lang => {
      switch (lang) {
        case "de":
          if (testLangs.test(path)) {
            if (testContact.test(path)) navigate("/kontakt")
            else if (testProcess.test(path)) navigate("/prozess")
            else navigate(path.replace(testLangs, ""))
          }
          break
        case "en":
          if (!testEnglish.test(path)) {
            if (testKontakt.test(path)) navigate("/en/contact")
            else if (testProzess.test(path)) navigate("/en/process")
            else navigate(`/en${path.replace(testChinese, "")}`)
          }
          break
        case "cn":
          if (!testChinese.test(path)) {
            if (testKontakt.test(path)) navigate("/cn/contact")
            else if (testProzess.test(path)) navigate("/cn/process")
            navigate(`/cn${path.replace(testEnglish, "")}`)
          }
          break
      }
    }
    if (!localLang) {
      localStorage.setItem("senses-integration-language", browserLang)
      redirectToLangPath(browserLang)
    } else {
      redirectToLangPath(localLang)
    }
  }, [path])
}
export default useRedirectToLang
